import React from "react";

//Third Party
import { useTable, useSortBy, useFilters } from "react-table";
import { useExportData } from "react-table-plugins";
import "jspdf-autotable";
//Styles
import "../../../../_metronic/assets/sass/components/CustomTable.scss";
import { KTIcon } from "../../../../_metronic/helpers";

import { CustomPagination, SquireIconWrapper } from "../lib";
import { useNavigate } from "react-router-dom";
import { DeleteModal } from "../lib/DeleteModal";
import { runToast } from "../../../../_metronic/helpers/utils";
import { deleteTicketListSpecial } from "../../../api/ticket/tikectSpecial";

interface TicketInPersonListTableProps {
  data: any; // Replace 'any' with the appropriate type for your data
  queryString: any;
  setQueryString: any;
  refetch: () => void;
  numberInPage: number | string;
}

const TicketInSpecialListTable = ({
  data,
  queryString,
  setQueryString,
  refetch,
  numberInPage,

}: TicketInPersonListTableProps) => {
  // Define a default UI for filtering
  function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
  }) {
    const count = preFilteredRows.length;

    return (
      <input
        value={filterValue || ""}
        onChange={(e) => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
        placeholder={`Search ${count} records...`}
      />
    );
  }

  const enum PayMethod {
    cash = "cash",
    online = "online",
  }
  const enum Status {
    reserved = "reserved",
    booked = "booked",
    cancelled = "cancelled",
  }

  const printPaymentMethod = (value: PayMethod) => {
    if (value === PayMethod.cash) {
      return "نقدی";
    }
    if (value === PayMethod.online) {
      return "آنلاین";
    }

    return "نامشخص";
  };

  const defaultColumn = {
    Filter: DefaultColumnFilter,
  };

  let columns = React.useMemo(
    () => [
      {
        Header: <HeaderTextIcon text={"ردیف"} />,
        accessor: "id",
        Cell: ({ value }) => <span className={"rowNum"}>{value}</span>,
      },

      {
        Header: <HeaderTextIcon text={"نام "} />,
        accessor: "name",
        Cell: ( value ) => {
          return (
            <span>
              {value?.row?.original?.attendee?.name}
            </span>
          );
        },
      },

      {
        Header: <HeaderTextIcon text={"کدملی"} />,
        accessor: "national_code",
        Cell: (value) => {
          return <span>{value?.row?.original?.attendee?.national_code}</span>;
        },
      },
      {
        Header: <HeaderTextIcon text={"تلفن"} />,
        accessor: "mobile",
        Cell: (value) => {
          return <span>{value?.row?.original?.attendee?.mobile}</span>;
        },
      },

      {
        Header: <HeaderTextIcon text={"تعداد تردد"} />,
        accessor: "remained",
        Cell: ( value ) => <span>{value?.row?.original?.remained}</span>,
      },
      {
        Header: <HeaderTextIcon text={" سازمان"} />,
        accessor: "organization.name",
        Cell: ( value ) => <span>{value?.row?.original?.organization?.title}</span>,
      },

      {
        Header: "",
        accessor: "actions",
        Cell: ({ value, row }) => {
          return (
            <IconsCell
              ticket={row.original}
              refetch={refetch}
              page={queryString.page}
            />
          );
        },
      },
    ],
    [queryString.page]
  );

  columns.reverse();
  // Create an instance of the useTable hook
  //@ts-ignore

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    //@ts-ignore

    exportData,
  } = useTable(
    //@ts-ignore

    { columns, data: data.ticket, defaultColumn },
    useFilters,
    useSortBy,
    useExportData
  );

  return (
    <div className={"p-c-30"}>
      <div style={{ overflow: "auto" }}>
        <table
          {...getTableProps()}
          style={{
            borderCollapse: "collapse",
            columnGap: "20px",
            direction: "ltr",
            minWidth: "100%",
          }}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, index) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>
                      {cell.column.id === "id" ? (
                        // Accessing row index here
                        <span className="rowNum">
                          {(queryString.page - 1) * Number(numberInPage) +
                            index +
                            1}
                        </span>
                      ) : (
                        cell.render("Cell")
                      )}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div
        className={"d-flex gap-4 py-4 my-8"}
        style={{
          borderBottom: "1px  solid #F1F1F4",
          borderTop: " 1px solid #F1F1F4",
        }}
      ></div>
      {/*Pagination start*/}
      <div style={{ marginRight: "auto" }}>
        <CustomPagination
          activePage={queryString.page}
          setQueryString={setQueryString}
          totalRows={data?.totalRows}
          numberInPage={numberInPage}
        />
      </div>
    </div>
  );
};

const HeaderTextIcon = ({ text }: { text: string }) => {
  return (
    <div
      className={"d-flex align-items-center justify-content-center gap-2"}
      style={{ whiteSpace: "nowrap", margin: "0 5px" }}
    >
      <span>{text}</span> <KTIcon iconName={"filter"} className={"fs-5"} />
    </div>
  );
};

const IconsCell = ({ ticket, refetch, page }: any) => {
  const icons = [
    {
      iconClass: "fc-12 color-red-c",
      iconName: "trash",
      wrapperClass: "bg-light-red-c",
    },
  ];
  const navigate = useNavigate();
  const [delItem, setDelItem] = React.useState<any>(null);
  const [showDelModal, setShowDelModal] = React.useState<boolean>(false);
  const handleActionClick = (icon: any, team: any) => {
    setDelItem(() => {
      return {
        id: ticket.id,
      };
    });
    setShowDelModal(true);
  };
  return (
    <>
      {showDelModal && (
        <DeleteModal
          delName={delItem?.title}
          delId={delItem?.id}
          show={showDelModal}
          handleHide={() => {
            setShowDelModal(false);
          }}
          deleteFunc={async () => {
            try {
              await deleteTicketListSpecial(delItem?.id);
              runToast("با موفقیت حذف شد", "success", { toastId: delItem.id });
              setShowDelModal(false);
              refetch();
            } catch (e) {
              console.log(e);
              runToast("مشکلی پیش آمده است دوباره تلاش کنید ", "error", {
                toastId: delItem.id,
              });
            }
          }}
        />
      )}
      <div className={"IconCell"}>
        {icons.map((icon) => (
          <a onClick={(e) => handleActionClick(icon, ticket)}>
            <SquireIconWrapper {...icon} />
          </a>
        ))}
      </div>
    </>
  );
};

export default TicketInSpecialListTable;
